<template>
  <div class="layout">
    <el-container>
      <el-aside width="200px">
        <el-menu :default-active="active">
          <el-menu-item
            v-for="(route,i) in menus"
            :key="i"
            :index="route.path"
            @click="routerTo(route.path)"
          >
            <i class="iconfont" :class="route.iconClass"></i>
            {{route.menu}}
          </el-menu-item>
        </el-menu>
      </el-aside>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import { router } from "@/router";
export default {
  name: "Layout",
  data() {
    return {
      menus: [],
      active: ""
    };
  },
  watch: {
    $route: function(val) {
      this.active = val.path;
    }
  },
  mounted: function() {
    this.init();
  },
  methods: {
    init: function() {
      router.options.routes.forEach(item => {
        if (item.menus) {
          this.menus = item.children;
        }
      });
      this.active = `/${this.$route.path.split("/")[1]}`;
    },
    routerTo: function(route) {
      this.$router.push(route);
    }
  }
};
</script>

<style>
.layout {
  width: 100%;
  height: 100%;
}
.el-aside {
  background-color: #d3dce6;
  color: #333;
}

body .el-container {
  height: 100%;
  background: #fff;
}
body .el-main {
  padding: 20px 200px 20px 20px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}
.el-menu {
  height: 100%;
}
</style>
